export enum StateTable {
	FACTURADA = 'Facturada',
	PROGRAMADA = 'Programada',
	DOCUMENTACION_ENVIADA = 'Documentación enviada',
	EJECUTADA = 'Ejecutada',
	CANCELADA = 'Cancelada',
	POSTPUESTA = 'Pospuesta',
	RECHAZADA = 'Rechazada',
	EN_PROGRESO = 'En progreso',
	DESCONOCIDO = 'Desconocido',
	CONFIRMADA = 'Confirmada',
	PLANIFICADA = 'Planificada',
}
